import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Head, router } from "@inertiajs/react";
import type { Following } from "@/types/generated";

interface FollowingProps extends Following {}

export default function Following({ following }: FollowingProps) {
  const handleUnfollow = (userId: number) => {
    router.delete(`/users/${userId}/unfollow`);
  };

  return (
    <>
      <Head title="Following" />

      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Following</h1>

        {following.length > 0 ? (
          <div className="space-y-4">
            {following.map((user) => (
              <Card key={user.id}>
                <CardContent className="p-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                      <div className="w-12 h-12 bg-gray-300 rounded-full flex items-center justify-center">
                        <span className="text-lg font-semibold text-gray-600">
                          {user.first_name[0]}
                          {user.last_name[0]}
                        </span>
                      </div>
                      <div>
                        <h3 className="font-semibold text-lg">
                          {user.first_name} {user.last_name}
                        </h3>
                      </div>
                    </div>
                    <Button
                      onClick={() => handleUnfollow(user.id)}
                      variant="outline"
                      className="text-red-600 border-red-600 hover:bg-red-50"
                    >
                      Unfollow
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <Card>
            <CardContent className="p-8 text-center">
              <p className="text-gray-600 text-lg">Not following anyone yet</p>
            </CardContent>
          </Card>
        )}
      </div>
    </>
  );
}
